import React from 'react';
import PendingDocsListComponent from './pending-docs-list.component';

const PendingDocsList = (props) => {
    return <PendingDocsListComponent {...props} />;
};

export default PendingDocsList;
